import * as RadixModal from "@radix-ui/react-dialog";
import React from "react";
import { BaseModalBlanket, BaseModalContent } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Modal(_ref) {
  var open = _ref.open,
    onEscapeKeyDown = _ref.onEscapeKeyDown,
    onPointerDownOutside = _ref.onPointerDownOutside,
    onInteractOutside = _ref.onInteractOutside,
    onOpenAutoFocus = _ref.onOpenAutoFocus,
    onCloseAutoFocus = _ref.onCloseAutoFocus,
    children = _ref.children,
    isLayeredModal = _ref.isLayeredModal;
  return /*#__PURE__*/_jsx(RadixModal.Root, {
    open: open,
    children: /*#__PURE__*/_jsxs(RadixModal.Portal, {
      children: [/*#__PURE__*/_jsx(BaseModalBlanket, {
        isLayeredModal: isLayeredModal
      }), /*#__PURE__*/_jsx(BaseModalContent, {
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onInteractOutside: onInteractOutside,
        onOpenAutoFocus: onOpenAutoFocus,
        onCloseAutoFocus: onCloseAutoFocus,
        isLayeredModal: isLayeredModal,
        children: children
      })]
    })
  });
}
export default Modal;